import { SxProps, Theme, styled } from '@mui/material';
import { Chip, SvgLock2Bold } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';

const StyledLock = styled(SvgLock2Bold)(() => ({
  fill: 'currentColor',
  transform: 'scale(67%)',
}));

type Props = {
  sx?: SxProps<Theme>;
};

const PrivateTag = ({ sx }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip
      icon={<StyledLock />}
      label={t('ui.event-management.teams.permissions.label-private')}
      color="grey"
      sx={sx}
    />
  );
};

export default PrivateTag;
